import color from '../methods/getColor';

const article = Object.freeze({
  marginStart: [
    { until: 'l', value: '0', },
    { from: 'l', until: 'xl', value: '27rem', },
    { from: 'xl', value: '30rem', },
  ],
  marginEnd: [
    { until: 'l', value: '0', },
    { from: 'l', until: 'xl', value: '57rem', },
    { from: 'xl', value: '51rem', },
  ],
  aside: [ { until: 'l', value: 'none', }, { from: 'l', value: 'block', }, ],
});

const paragraphLink = Object.freeze({
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomWidthActive: '2px',
});

const articleLink = Object.freeze({
  typeScale: [
    { until: 's', value: 0, },
    { from: 's', value: -1, },
  ],
  baseLinkStylesExtend: ({ theme, }) => ([
    theme.type(-1, { untilBp: 'xl', }),
    theme.type(-2, { fromBp: 'xl', }),
  ]),
});

const body = Object.freeze({
  marginBottom: [ { until: 'xl', value: '4rem', }, { from: 'xl', value: '3rem', }, ],
  width: [ { from: 'l', until: 'xl', value: '70.5rem', }, { from: 'xl', value: '80rem', }, ],
  marginStart: [
    { until: 'm', value: '2rem', },
    { from: 'm', until: 'l', value: '10rem', },
    { from: 'l', value: '4rem', },
  ],
  marginEnd: [ { until: 'm', value: '2rem', }, { from: 'm', until: 'l', value: '10rem', }, ],
  displayTldr: true,
});

const paragraphStyles = Object.freeze({});

const inlineKicker = {
  backgroundColor: 'transparent',
  color: color('tertiary'),
  separator: '|',
};

const blockKicker = {
  backgroundColor: color('tertiary'),
  color: color('neutral', '-10'),
};

/**
 * Contains theme for article header elements: kicker, title
 * @type {Object}
 */
const header = Object.freeze({
  kickerFontSize: [
    { until: 'm', value: 3, },
    { from: 'm', until: 'l', value: 4, },
    { from: 'l', until: 'xl', value: 5, },
    { from: 'xl', value: 6, },
  ],
  titleFontSize: [
    { until: 'm', value: 3, },
    { from: 'm', until: 'l', value: 4, },
    { from: 'l', until: 'xl', value: 5, },
    { from: 'xl', value: 6, },
  ],
  headlineElementCaptionMiscStyles: {
    paddingInlineStart: '1rem',
    paddingTop: '0.5rem',
  },
  breadcrumbs: {
    type: [ { until: 'l', value: 0, }, { from: 'l', value: -1, }, ],
    margins: {
      marginTop: [ { until: 's', value: '2rem', }, ],
    },
  },
  subTitleMarginTop: '1rem',
  articleHeaderMetaCreditMarginTop: '0.5rem',

  inlineKicker,
  blockKicker,
  subtitleFontSize: [ { until: 'xl', value: 0, }, { from: 'xl', value: 1, }, ],
  bylineCreditColor: color('primary', '+1'),
  bylineFontSize: [
    { until: 's', value: -2, },
    { from: 's', until: 'm', value: -2, },
    { from: 'm', until: 'l', value: -1, },
    { from: 'l', value: -1, },
  ],
  marginStart: [ { until: 'l', value: '2rem', }, { from: 'l', value: '4rem', }, ],
  marginEnd: [ { until: 'm', value: '2rem', }, { from: 'm', until: 'l', value: '2rem', }, ],
  showFacebookEngagementCount: false,
  metaTopMarginMobile: '5rem',
  metaBottomMarginMobile: '2rem',
  authorFontSize: [ { until: 's', value: -1, }, ],
});

const articleStyle = Object.freeze({
  article,
  articleLink,
  header,
  body,
  paragraphStyles,
  paragraphLink,
});

export default articleStyle;
